export { default as useCacheProduct } from './useCacheProduct';
